import { ProductosRestriccionesActividades } from './../_models/producto-restriccion-actividad';
import { AppSettings } from './../../proyect.conf';
import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductoRestriccionActividadService {
  private rutServicio =
    AppSettings.rutServiciosAPL + '/api/productosRestriccionesActividades';

  constructor(
    private httClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listado() {
    return this.httClient
      .get(this.rutServicio)
      .pipe(map((res) => res as ProductosRestriccionesActividades[]));
  }

  listadoHabilitados() {
    return this.httClient
      .get(this.rutServicio + '/enabled')
      .pipe(map((res) => res as ProductosRestriccionesActividades[]));
  }

  listadoPorProducto(idProducto: string) {
    return this.httClient
      .get(this.rutServicio + '/productos/' + idProducto)
      .pipe(map((res) => res as ProductosRestriccionesActividades[]));
  }

  listadoPorProductoHabilitados(idProducto: string) {
    return this.httClient
      .get(this.rutServicio + '/productos/' + idProducto + '/enabled')
      .pipe(map((res) => res as ProductosRestriccionesActividades[]));
  }

  crear(regCrear: ProductosRestriccionesActividades) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as ProductosRestriccionesActividades));
  }

  actualizar(regActualizar: ProductosRestriccionesActividades) {
    regActualizar.auditoriaUsuario =
      this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as any));
  }
}
